"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketRequestPaymentInput_1 = require("./PutBucketRequestPaymentInput");
var PutBucketRequestPaymentOutput_1 = require("./PutBucketRequestPaymentOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketRequestPayment = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketRequestPayment",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?requestPayment"
    },
    input: {
        shape: PutBucketRequestPaymentInput_1.PutBucketRequestPaymentInput
    },
    output: {
        shape: PutBucketRequestPaymentOutput_1.PutBucketRequestPaymentOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketRequestPayment.js.map